import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import styles from "Styles/CompanySize.module.css";
// import emoji from "Assets/emoji/party.png";

const PrivacySendInfoContent = ({ companyName }) => {
  return (
    <InfoContentMotionWrapper>
      {/* <div style={{ position: "absolute", top: "0" }}>
        <img src={emoji} alt="Party Emoji" className={styles.emoji} />
        <h2 className={styles.heading} style={{ marginBottom: "2rem" }}>
          ＼ 恭喜！你已完成行銷競爭力健檢！ ／
        </h2>
      </div> */}
      <h3 className={styles.heading}>
        我們已根據你的填答，
        <br />
        完成 {companyName || "您"} 專屬的行銷現況分析。
      </h3>
    </InfoContentMotionWrapper>
  );
};

export default PrivacySendInfoContent;
